import { useEffect, useState } from 'react';
import { fetchApiRef, useApi } from '@backstage/core-plugin-api';

export function ZendeskConnectPage() {
	const fetchApi = useApi(fetchApiRef);
	const [error, setError] = useState<string>();

	useEffect(() => {
		let active = true;

		void fetchApi.fetch('/api/zendesk/oauth/start?format=json')
			.then(response => {
				if (!response.ok) {
					throw new Error(`Zendesk connection could not start (${response.status}).`);
				}
				return response.json() as Promise<{ authorizeUrl?: string }>;
			})
			.then(({ authorizeUrl }) => {
				if (!authorizeUrl) {
					throw new Error('Zendesk connection did not return an authorization URL.');
				}
				window.location.assign(authorizeUrl);
			})
			.catch(reason => {
				if (active) {
					setError(reason instanceof Error ? reason.message : 'Zendesk connection could not start.');
				}
			});

		return () => {
			active = false;
		};
	}, [fetchApi]);

	return <p>{error ?? 'Connecting to Zendesk...'}</p>;
}